import * as tslib_1 from "tslib";
import { ErrorHandler } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import SkinJson from '../../../assets/sample/skin.json';
var SkinService = /** @class */ (function () {
    function SkinService(http, _errorHandler) {
        this.http = http;
        this._errorHandler = _errorHandler;
    }
    SkinService.prototype.load = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                try {
                    setTimeout(function () {
                        // @ts-ignore
                        var $head = $('head');
                        // @ts-ignore
                        var $body = $('body');
                        // @ts-ignore
                        var $headerContainer = $('.app__header-container');
                        // @ts-ignore
                        var $footerContainer = $('.app__footer-container');
                        // Fetch the skin components - this is from the old webservice on Coldfusion
                        // const skin = await this.http.get<Skin>(environment.skinServiceUrl, { withCredentials: true }).toPromise();
                        // the skin is now in a JSON file in the local assets folder
                        var skin = SkinJson;
                        // Add the skins components to the page
                        $head.append(skin.css);
                        $body.prepend(skin.svg);
                        $headerContainer.prepend(skin.header);
                        skin.footer = skin.footer.replace('DatePlaceholder', new Date().getFullYear());
                        $footerContainer.append(skin.footer);
                        $body.append(skin.js);
                        // Initialize the header
                        Aopa.header.init({
                            mini: true,
                            sticky: false
                        });
                    }, 4000);
                }
                catch (e) {
                    this._errorHandler.handleError(e);
                }
                return [2 /*return*/];
            });
        });
    };
    return SkinService;
}());
export { SkinService };
